import React, { Component } from "react";
import { connect } from "react-redux";
import { func, bool, arrayOf, shape, string } from "prop-types";
import { push } from "connected-react-router";
import moment from "moment";
import { selectors as investmentfundsSelectors, actions as investmentfundsActions } from "reducers/investmentfunds";

import * as i18n from "util/i18n";

import Col from "react-bootstrap/lib/Col";
import PageLoading from "pages/_components/PageLoading";
import CustomProductHead from "pages/_components/CustomProductHead";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import MainContainer from "pages/_components/MainContainer";
import Grid from "react-bootstrap/lib/Grid";
import Row from "react-bootstrap/lib/Row";
import Notification from "pages/_components/Notification";
import Image from "pages/_components/Image";
import Button from "pages/_components/Button";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import I18n from "pages/_components/I18n";

class ProfileInfo extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        fetching: bool.isRequired,
        investorProfile: arrayOf(shape({})).isRequired,
        lastTestDate: string,
        expired: bool,
        firstTest: bool,
        testUpdateMessage: string,
    };

    static defaultProps = {
        lastTestDate: null,
        expired: false,
        firstTest: false,
        testUpdateMessage: null,
    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(investmentfundsActions.investorProfileRead());
    }

    renderMenuOption = () => {
        const { dispatch, lastTestDate, expired } = this.props;
        return (
            <div
                className="toolbar-item add-button"
                key="add"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: 300,
                    textAlign: "center",
                }}>
                <div>
                    <p>
                        {i18n.get("investmentFunds.investorTest.profile.lastTest.date", null, {
                            LAST_TEST_DATE:
                                lastTestDate ||
                                moment(new Date())
                                    .utc()
                                    .format("DD/MM/YYYY"),
                        })}
                    </p>
                </div>
                {!expired && (
                    <div>
                        <CustomButton
                            func={() => dispatch(push("/investorTest"))}
                            className="btn btn-primary btn-block"
                            text="investmentFunds.investorTest.profile.update"
                            textType="I18N"
                        />
                    </div>
                )}
            </div>
        );
    };

    getTitle = () => {
        const { firstTest, testUpdateMessage } = this.props;
        if (firstTest) {
            return "investmentFunds.investorTest.finish";
        }
        if (testUpdateMessage) {
            return testUpdateMessage;
        }
        return "investmentFunds.investorTest.profile.title";
    };

    render() {
        const { investorProfile, fetching, dispatch, expired, firstTest } = this.props;

        return (
            <PageLoading loading={fetching}>
                <Notification scopeToShow="investmentfunds" />
                <CustomProductHead
                    titleId={this.getTitle()}
                    className="new-deposit-request"
                    addLinkToLabel="investmentFunds.investorTest.profile.update"
                    addLinkTo="/investorTest"
                    renderMenuOption={this.renderMenuOption}>
                    <div className="toolbar-item view-title">
                        <ViewTitle id={this.getTitle()} />
                    </div>
                </CustomProductHead>
                <MainContainer className="main-container">
                    <Grid className="form-content">
                        <Row className="justify-content-center">
                            <div className="illustration text-center">
                                <Image src="images/figma/illustrations/onboarding9.svg" className="svg-image logo" />
                                <Col xs={12} md={10} mdOffset={1}>
                                    <I18n id={`investmentFunds.investorTest.profile.type.${investorProfile}`} />
                                </Col>
                            </div>

                            <Col xs={12} md={10} mdOffset={1}>
                                <h2>{i18n.get("investmentFunds.investorTest.profile.aboutTitle")}</h2>
                                <div style={{ textAlign: "justify" }}>
                                    {i18n.get(
                                        `investmentFunds.investorTest.profile.type.${investorProfile}.description`,
                                    )}
                                </div>
                            </Col>
                        </Row>

                        <Row className="form-actions">
                            <Col xs={12} md={4} mdOffset={4}>
                                {expired && (
                                    <CustomButton
                                        func={() => dispatch(push("/investorTest"))}
                                        className="btn btn-primary btn-block"
                                        text="investmentFunds.investorTest.profile.update"
                                        textType="I18N"
                                    />
                                )}
                                {firstTest ? (
                                    <Button
                                        onClick={() => dispatch(push("/investmentFunds/accounts/add/ddjj"))}
                                        label="global.continue"
                                        className="btn btn-primary btn-block"
                                    />
                                ) : (
                                    <Button
                                        onClick={() => dispatch(push("/desktop"))}
                                        label="forms.transaction.ticket.actions.backToHome"
                                        className="btn btn-outline"
                                    />
                                )}
                            </Col>
                        </Row>
                    </Grid>
                </MainContainer>
            </PageLoading>
        );
    }
}
const mapStateToProps = (state) => ({
    fetching: investmentfundsSelectors.getFetching(state),
    investorProfile: investmentfundsSelectors.getInvestorProfile(state),
    lastTestDate: investmentfundsSelectors.getLastTestDate(state),
    expired: investmentfundsSelectors.getExpired(state),
    firstTest: investmentfundsSelectors.getFirstTest(state),
    testUpdateMessage: investmentfundsSelectors.getTestUpdateMessage(state),
});
export default connect(mapStateToProps)(ProfileInfo);
